import { APP_ID, Provider } from "@angular/core";

import { appId } from "@hiptraveler/common";

export const AppIdProvider: Provider = {
  provide: APP_ID,
  useValue: appId
};
